// src/modules/app-views/account/pages/Subscription/modals/CscTokenModal/Step1.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { useEffect } from 'react';
import { Alert, Space, Button, Typography } from 'antd';
import { LinkOutlined } from '@ant-design/icons';
import translateX from 'utils/translateX';
import { useSimpleFormContext } from 'components/SimpleComponents/SimpleFormProvider';
import SimplePassword from 'components/SimpleComponents/SimplePassword';
import fiscalService from 'services/fiscalService';

const { Text } = Typography;

// *******************************************************************************
// STEP CONTENT COMPONENT
// *******************************************************************************
const CscTokenStepContent = () => {
  const { form, goFocus } = useSimpleFormContext();

  // Get UF from form initial values (passed from FiscalTab)
  const uf = form?.getFieldValue('_uf');

  // Get SEFAZ CSC link for the state
  const cscLink = fiscalService.getCscLinks(uf, 'url');
  const cscStateName = fiscalService.getCscLinks(uf, 'name');
  const cscNote = fiscalService.getCscLinks(uf, 'note');

  // Auto-focus the token field when step mounts
  useEffect(() => {
    const timer = setTimeout(() => {
      goFocus?.('cscToken', true);
    }, 150);
    return () => clearTimeout(timer);
  }, [goFocus]);

  // Handle open SEFAZ link
  const handleOpenSefazLink = () => {
    if (cscLink) {
      window.open(cscLink, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <Space orientation="vertical" style={{ width: '100%' }} size="middle">
      <Alert
        title={translateX('csc_token_info')}
        description={
          <Space orientation="vertical" size="small" style={{ width: '100%' }}>
            <Text>{translateX('csc_token_info_description')}</Text>
            {cscLink && (
              <div style={{ textAlign: 'right', marginTop: 8 }}>
                <Text>{translateX('get_csc_token_at')}:</Text>
                <br />
                <Button
                  type="link"
                  size="small"
                  icon={<LinkOutlined />}
                  onClick={handleOpenSefazLink}
                  style={{ padding: 0 }}
                >
                  {cscStateName ? `Sefaz ${cscStateName}` : translateX('sefaz_portal')}
                </Button>
              </div>
            )}
            {/*{cscNote && (*/}
            {/*  <Text type="secondary" style={{ fontSize: 12 }}>*/}
            {/*    {cscNote}*/}
            {/*  </Text>*/}
            {/*)}*/}
          </Space>
        }
        type="info"
        showIcon
      />

      <SimplePassword
        name="cscToken"
        label="csc_token"
        required
        autoComplete="off"
        placeholder="XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX"
        minLength={16}
        maxLength={40}
      />
    </Space>
  );
};

// *******************************************************************************
// STEP CONFIGURATION
// *******************************************************************************
const cscTokenStep = () => ({
  stepTitle: 'csc_token',
  stepTooltip: 'configure_csc_token',
  content: () => <CscTokenStepContent />,
  validationFields: ['cscToken'],
});

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default cscTokenStep;
